import LockPersonOutlinedIcon from "@mui/icons-material/LockPersonOutlined";
import {
  AccordionDetails,
  AccordionSummary,
  Grid2,
  TableCell,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import ExpandIco from "../../../assets/icons/ExpandIco";
import UnLockIco from "../../../assets/icons/UnLockIco";
import CommonButton from "../../../component/Button";
import SnackBar from "../../../component/SnackBar";
import { JobJobLock, JobSummary } from "../../../redux/action/Job";
import { getColor } from "../../../utils/constants";
import CommonTable from "../../candidates/Table";
import { CustomDiv } from "../../chat-bot/style";
import {
  CommonGrid2,
  CustomAccordion,
  CustomLinearProgress,
  StyledFlexRowView,
  StyledTypoGrey,
} from "../../common-components/StyledComponents";
import Interactions from "./components/Interactions";
import Results from "./components/Results";
import Skills from "./components/Skills";
import SummaryInteractionDialog from "./components/SummaryInteractionDialog";
import ShareQuickMatch from "../../matches/quick-match/components/ShareQuickMatch";
import { DynamicIntelligenceShare } from "../../../redux/action/DynamicIntelligence";

function JobsSummary({ fetchData, condition_based }) {
  const localStorageData = JSON.parse(localStorage.getItem("credential"));
  const SummaryJobData = useSelector((state) => state.jobs.jobSummary);
  const query = new URLSearchParams(useLocation().search);
  const jobId = query.get("id");
  const jobStatus = query.get("status");
  const dispatch = useDispatch();
  const [tableLoader, setTableLoader] = useState(false);
  const resultHeaderData = [
    { name: "Name" },
    { name: "Type" },
    { name: "Score" },
    { name: "" },
  ];
  const [interActionOpen, setInterActionOpen] = useState(false);
  const [interActionData, setInterActionData] = useState({});
  const interactionHeaderData = [
    "ID",
    "Type",
    "Action",
    "Result",
    "Date",
    "Time",
    "Made By",
    "",
  ];

  const [dragContent, setDragContent] = useState(
    SummaryJobData?.results?.candidates || []
  );
  const candidateBestCounts = {};

  const [lock, setLock] = useState({
    content: "UnLock",
    loading: false,
    error: false,
  });

  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [shareDialogOpen, setShareDialogOpen] = useState(false);

  const fetchSummaryDetails = async () => {
    try {
      setTableLoader(true);
      let params = {};
      if (
        localStorageData?.organization === "Demo" &&
        localStorageData?.role === "Demo" &&
        query.get("is_demo") === "true"
      ) {
        params = {
          is_demo: true,
        };
      }
      await dispatch(JobSummary(jobId, params));
      setTableLoader(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error?.data?.message || error?.message,
        severity: "error",
      });
      setTableLoader(false);
    }
  };

  useEffect(() => {
    fetchSummaryDetails();
  }, [jobId]);

  useEffect(() => {
    setDragContent(SummaryJobData?.results?.candidates);
  }, [SummaryJobData]);
  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleInteractionAction = (data) => {
    setInterActionOpen(true);
    setInterActionData(data);
  };

  const handleShareDialogClose = () => {
    setShareDialogOpen(false);
  }

  const handleShareInvite = async (shareData) => {
    setShareDialogOpen((prev) => ({ ...prev, loading: true }));
    try {
      let payload = {
        url: window.location.href,
        to_email: shareData,
        emails: shareData.map((item) => item.email),
        job_id: jobId,
        job_name: query.get("title") || "",
      };
      const data = await DynamicIntelligenceShare(payload, jobId);
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
      handleShareDialogClose();
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setShareDialogOpen((prev) => ({ ...prev, loading: false }));
    }
  };

  const handleTableBodyData = (item) => (
    <Fragment>
      <TableCell>
        <Typography
          fontSize={"14px"}
          fontWeight={500}
          color={"#101828"}
          fontFamily={"Inter"}
        >
          {item.candidate_name}
        </Typography>
      </TableCell>
      <TableCell>
        <CustomDiv
          background={
            item.record_type === "GOLDEN RECORD" ? "#DAFDF5" : "#F7F1FF"
          }
          width="max-content"
          border={
            item.record_type === "GOLDEN RECORD"
              ? "1px solid #C3FFF1"
              : "1px solid #EAECF0"
          }
          padding="5px 15px"
          color={item.record_type === "GOLDEN RECORD" ? "#049F9A" : "#6941C6"}
          fontSize="13px"
          fontWeight={600}
          borderRadius="50px"
        >
          {item.record_type
            ?.toLowerCase()
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")}
        </CustomDiv>
      </TableCell>
      <TableCell style={{ width: "20vw" }}>
        <StyledFlexRowView sx={{ alignItems: "center" }}>
          <CustomLinearProgress
            variant="determinate"
            value={item.score}
            height={"10px"}
            borderRadius={"5px"}
            barbackgroundColor={getColor(item.score)}
          />

          <StyledTypoGrey>{`${item.score}%`}</StyledTypoGrey>
        </StyledFlexRowView>
      </TableCell>
    </Fragment>
  );

  const onDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination || destination.index === source.index) return;

    const reorderedCandidates = [...dragContent];
    const [removed] = reorderedCandidates.splice(source.index, 1);
    reorderedCandidates.splice(destination.index, 0, removed);

    setDragContent(reorderedCandidates);
  };

  SummaryJobData &&
    SummaryJobData.skill.length !== 0 &&
    SummaryJobData?.skill?.forEach((skillItem) => {
      skillItem.candidates.forEach((candidate) => {
        if (candidate.is_best_candidate) {
          candidateBestCounts[candidate.name] =
            (candidateBestCounts[candidate.name] || 0) + 1;
        }
      });
    });

  const attributeHeaderData = [
    { title: "Skill", width: "210px" },
    ...(SummaryJobData?.skill?.length
      ? SummaryJobData.skill[0].candidates.map((item) => ({
          title: item.name,
          count: candidateBestCounts[item.name] || 0,
        }))
      : []),
    { title: "Top in Skill", width: "150px" },
    { title: "" },
  ];

  const accordionDataView = [
    {
      title: (
        <StyledFlexRowView>
          Results
          <Typography fontSize={"20px"} fontWeight={600} color={"#667085"}>
            · {SummaryJobData?.results?.count}
          </Typography>
        </StyledFlexRowView>
      ),
      component: (
        <Fragment>
          <Typography
            variant="body5"
            margin={"0rem 0rem 0.8rem -0.5rem"}
            display={"flex"}
          >
            Candidate
          </Typography>
          <Results
            SummaryJobData={SummaryJobData}
            lock={lock}
            tableLoader={tableLoader}
            resultHeaderData={resultHeaderData}
            onDragEnd={onDragEnd}
            dragContent={dragContent}
          />
          {SummaryJobData &&
            SummaryJobData?.results &&
            (SummaryJobData?.results?.hiring_manager?.length !== 0 ||
              SummaryJobData?.results?.golden_record?.length !== 0) && (
              <Fragment>
                <Typography
                  variant="body5"
                  margin={"1.8rem 0rem 0px -0.5rem"}
                  display={"flex"}
                >
                  Hiring Manager & Golden Record
                </Typography>
                <CommonTable
                  marginTop={"0.8rem"}
                  loading={tableLoader}
                  loadingRowLength={2}
                  columns={resultHeaderData.filter((item) => item.name !== "")}
                  data={[
                    ...(SummaryJobData?.results?.hiring_manager || []),
                    ...(SummaryJobData?.results?.golden_record || []),
                  ]}
                  handleTableBodyData={handleTableBodyData}
                />
              </Fragment>
            )}
        </Fragment>
      ),
    },
    {
      title: "LeaderBoard",
      component: (
        <Skills
          attributeHeaderData={attributeHeaderData}
          SummaryJobData={SummaryJobData}
          tableLoader={tableLoader}
        />
      ),
    },
    {
      title: "Interactions",
      component: (
        <Interactions
          SummaryJobData={SummaryJobData}
          interactionHeaderData={interactionHeaderData}
          tableLoader={tableLoader}
          handleInteractionAction={handleInteractionAction}
        />
      ),
    },
  ];

  const handleLock = async (e) => {
    e.stopPropagation();
    if (lock.content === "UnLock") {
      setLock({
        content: "Lock",
        loading: false,
        error: false,
      });
    }

    // else if (
    //   JSON.stringify(SummaryJobData?.results?.candidates) ==
    //   JSON.stringify(dragContent)
    // ) {
    //   setLock((prev) => ({
    //     ...prev,

    //     error: true,
    //   }));
    //   setTimeout(() => {
    //     setLock((prev) => ({
    //       ...prev,
    //       error: false,
    //     }));
    //   }, [1500]);
    // }
    else if (lock.content === "Lock") {
      setLock((prev) => ({
        ...prev,
        loading: true,
        error: false,
      }));
      let params = {};
      if (
        localStorageData?.organization === "Demo" &&
        localStorageData?.role === "Demo" &&
        query.get("is_demo") === "true"
      ) {
        params = {
          is_demo: true,
        };
      }

      try {
        const data = await JobJobLock(dragContent);
        setTableLoader(true);
        await dispatch(JobSummary(jobId, params));
        fetchData();
        setSnackbarState({
          open: true,
          message: data.message,
          severity: "success",
        });
        setLock({
          content: "UnLock",
          loading: false,
          error: false,
        });
        setTableLoader(false);
      } catch (error) {
        setSnackbarState({
          open: true,
          message: error?.data?.message || error?.message,
          severity: "error",
        });
        setLock({
          content: "Lock",
          loading: false,
          error: false,
        });
      }
    }
  };

  console.log(SummaryJobData,'sfjsfkjskjsljksj');

  return (
    <Grid2 container spacing={3}>
      <Grid2 size={12} spacing={2} container>
        {accordionDataView.map((item, index) => (
          <Grid2 item size={12}>
            <CustomAccordion
              ContentMargin={"0px !important"}
              paddingBottom={"1rem"}
              defaultExpanded={index === 0}
            >
              <AccordionSummary
                expandIcon={<ExpandIco />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
              >
                <CommonGrid2
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                  size={12}
                >
                  <Typography variant="h4" fontWeight={600}>
                    {item.title}
                  </Typography>
                  {index == 0 && (
                    <CommonGrid2
                      display={"flex"}
                      alignItems={"end"}
                      flexDirection={"column"}
                      marginRight={"15px"}
                    >
                      <CommonGrid2
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"center"}
                        flexDirection={"row"}
                        gap={"1rem"}
                      >
                      {SummaryJobData?.share_dynamic_intelligence && (
                        <CommonButton
                            variant="outlined"
                            value="Share Dynamic Intelligence"
                            padding="10px 20px"
                            color="#344054"
                            border="#D0D5DD"
                            fontWeight="600"
                            onClick={(e) => {
                              e.stopPropagation();
                              setShareDialogOpen(true);
                            }}
                        />
                      )}
                      <Tooltip
                        title={`Kindly ${lock.content} to order the content`}
                        arrow
                        placement="top"
                      >
                        <div style={{ width: "max-content" }}>
                          <CommonButton
                            variant="outlined"
                            padding={"10px"}
                            startIcon={
                              lock.loading ? (
                                ""
                              ) : lock.content === "Lock" ? (
                                <LockPersonOutlinedIcon />
                              ) : (
                                <UnLockIco />
                              )
                            }
                            color="#344054"
                            border="#D0D5DD"
                            fontWeight="600"
                            // value={lock.content}
                            height="max-content"
                            onClick={(e) => handleLock(e)}
                            loading={lock.loading}
                            disabled={
                              lock.loading ||
                              jobStatus === "Closed" ||
                              jobStatus === "Cancelled" ||
                              jobStatus === "Filled" ||
                              condition_based
                            }
                            borderRadius={"7px"}
                            // gap={lock.loading ? "10px" : "0px"}
                            customStyle={{
                              pointerEvents: "all",
                              cursor: "pointer",
                              "&:hover svg path": {
                                fill: "#fff",
                              },
                              "& .MuiButton-icon": {
                                margin: "0px",
                              },
                            }}
                          />
                        </div>
                      </Tooltip>
                      {/* {lock.error && (
                      <ErrorContent>
                        Kindly change the order to update it
                      </ErrorContent>
                    )} */}
                    </CommonGrid2>
                    </CommonGrid2>
                  )}
                </CommonGrid2>
              </AccordionSummary>
              <AccordionDetails>
                <Grid2 size={12}>{item.component}</Grid2>
              </AccordionDetails>
            </CustomAccordion>
          </Grid2>
        ))}
      </Grid2>

      <SummaryInteractionDialog
        open={interActionOpen}
        handleClose={() => setInterActionOpen(false)}
        interActionData={interActionData}
      />
      <ShareQuickMatch
        title="Share Job as Dynamic Intelligence"
        shareDialogOpen={shareDialogOpen}
        handleShareDialogClose={handleShareDialogClose}
        handleShareInvite={handleShareInvite}
        // isLoading={shareDialogOpen.loading}
        condition={"summary"}
      />
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </Grid2>
  );
}

export default JobsSummary;
